// BS26 "B26 join" REG page — SMS ask for email (non-SMS) visitors (anh 11-03 brief: "when we send this page by email,
// some recipients are NOT SMS subscribers yet — persuade them to leave their phone number").
// SMS links carry `s-id` (Postscript subscriber id) -> already an SMS subscriber -> state A: upgrade the on-the-list
// copy to "text". Email links carry Klaviyo `_kx` -> dry-check the shared onetap endpoint (text/plain POST
// {brand, kx, dry:true}); ok:true -> state A; error no-phone/not-subscriber -> state B: open the SMS-ask block at the
// top of the card. Any other outcome (other error, timeout, no id at all) -> state C, which is simply the page's
// default render (neutral copy + the small "Want it by text?" line) — nothing to do.
// Reuses the SAME endpoint URL as assets/bs26-sale-list-onetap-join-for-sms-visitors.js but is its OWN copy (that file
// never runs its dry check on REG — isReg guard — and is never edited here). Loaded only when section setting
// reg_mode is true; the live (non-REG) b26-join page never loads this file. QA: ?smsask=1 forces state B open.
(function () {
  const ENDPOINT = 'https://script.google.com/macros/s/AKfycbzVp2-_WObmVKv3pyC7bmM4pdIJYnztFHstxyG_zPRZRKvglSopX3zeBWqqbQHsURWb/exec';
  const C = window.SLQ_CONFIG, T = window.SLQ_TRACK || { listAction() {} };
  const qs = new URLSearchParams(location.search);
  const sid = (qs.get('s-id') || '').trim(), kx = (qs.get('_kx') || '').trim();
  const viaSid = /^\d{5,12}$/.test(sid), viaKx = !viaSid && /^[A-Za-z0-9_.\-]{8,300}$/.test(kx);
  const store = { get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (_) {} } };
  const $1 = (sel) => document.querySelector(sel);

  // State A: visitor is a confirmed SMS subscriber — "we'll text" copy, no need to ask for a number.
  function showStateA() {
    const neutral = $1('[data-lp-reg-copy-neutral]'), text = $1('[data-lp-reg-copy-text]'), line = $1('[data-lp-reg-askline]');
    if (neutral) neutral.hidden = true;
    if (text) text.hidden = false;
    if (line) line.hidden = true;
  }
  // State B: open the ask block (top of the card), hide the small secondary line (now redundant).
  function showStateB() {
    const ask = $1('[data-lp-smsask]'); if (!ask) return;
    ask.hidden = false;
    const line = $1('[data-lp-reg-askline]'); if (line) line.hidden = true;
    sticky(true);
    T.listAction('b26j-reg-smsask', 'shown');
  }
  // Mobile sticky (hero-sticky reads C.stickyLabels.quiz / C.stickyTarget on every update): while the ask is open it
  // points back to the ask card, not to the referral card — getting this visitor's number comes first.
  function sticky(ask) {
    if (!C) return;
    C.stickyLabels = Object.assign({}, C.stickyLabels, { quiz: ask ? 'GET THE LINK BY TEXT' : 'SEND A FRIEND THE LINK' });
    C.stickyTarget = ask ? 'lp-card' : 'b26j-ref';
  }
  // After a tap/submit: collapse the ask body into a short confirmation, remember it so a return visit stays collapsed.
  function collapseAsk() {
    const ask = $1('[data-lp-smsask]'); if (!ask) return;
    ask.hidden = false;
    ask.querySelectorAll('[data-lp-smsask-body]').forEach((el) => { el.hidden = true; });
    const done = $1('[data-lp-smsask-done]'); if (done) done.hidden = false;
    store.set('slq-smsask-done', '1');
    sticky(false);
  }

  if (store.get('slq-smsask-done') === '1') collapseAsk();
  else if (qs.get('smsask') === '1') showStateB(); // QA preview: force state B open
  else if (viaSid) showStateA();
  else if (viaKx) {
    document.addEventListener('DOMContentLoaded', async () => {
      try {
        const ctl = new AbortController(); const t = setTimeout(() => ctl.abort(), 6000);
        const res = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ brand: String((C && C.brand) || '').toLowerCase(), kx, dry: true }), signal: ctl.signal });
        clearTimeout(t); const j = await res.json();
        if (j && j.ok) showStateA();
        else if (j && (j.error === 'no-phone' || j.error === 'not-subscriber')) showStateB();
        // any other error (kx/brand/bad-json) → unknown → state C stands (default copy already on the page)
      } catch (_) { /* timeout/network error → state C stands */ }
    });
  }
  // else: no id at all → state C stands (default neutral copy + "Want it by text?" line already rendered)

  document.addEventListener('click', (e) => {
    const line = e.target.closest('[data-lp-reg-asklink]');
    if (line && window.matchMedia('(min-width: 900px)').matches) { // desktop: reveal the ask block instead of a no-op sms: link
      e.preventDefault(); showStateB();
      const tel = $1('#lp-tel-reg'); if (tel) tel.focus();
      return;
    }
    if (e.target.closest('[data-lp-smsask-text]')) { T.listAction('b26j-reg-smsask', 'sms-tap'); setTimeout(collapseAsk, 400); return; }
    if (e.target.closest('[data-lp-smsask-showphone]')) {
      T.listAction('b26j-reg-smsask', 'phone-reveal');
      const f = $1('[data-lp-smsask-phoneform]'); if (f) f.classList.add('is-open');
      const tel = $1('#lp-tel-reg'); if (tel) tel.focus();
    }
  });

  const form = $1('[data-lp-smsask-phoneform]');
  if (form) form.addEventListener('submit', (e) => {
    if (!form.checkValidity()) return;
    const d = window.SLQ_ASK ? window.SLQ_ASK.checkPhone(form, e) : form.querySelector('input[name="phone"]').value;
    if (!d) return;
    T.listAction('b26j-reg-smsask', 'phone-submit');
    const ok = $1('[data-lp-smsask-ok]'); if (ok) ok.hidden = false;
    setTimeout(collapseAsk, 1200);
  });
})();
